import Segments from ".";
import PostToSegment from "../PostToSegment";
import EditSegment from "./_components/EditSegment";
import InviteToSegment from "./_components/InviteToSegment";
import ManageSpaces from "./ManageSpaces";
import SegmentSpaces from "./SegmentSpaces";

export const segmentsRoutes = [
  {
    path: "/lists",
    exact: true,
    main: Segments,
  },
  {
    path: "/lists/:id/spaces",
    exact: true,
    main: SegmentSpaces,
  },
  {
    path: "/lists/:id/spaces/edit",
    exact: true,
    main: ManageSpaces,
  },
  {
    path: "/lists/:id/edit",
    exact: true,
    main: EditSegment,
  },

  {
    path: "/lists/:id/add_members",
    exact: true,
    main: InviteToSegment,
  },

  {
    path: "/lists/:id/spaces/post",
    exact: true,
    main: PostToSegment,
  },
];
